import React from 'react';
import classnames from 'classnames';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { layoutConfig } from 'config/table-configs/auth-member-search';
import { searchInputPreloader as SearchInputPreloader } from 'ui/views/generic/searchInput';
import { TABLE_TEMPLATE_TYPE } from 'constants/common';

// Success view
export const authFlowMemberVerificationMemberSearchWidgetSuccess = ( props ) => {
    
    // dynamic class name
    const widgetClassName = classnames( 'ui-auth-flow-member-verification-member-search-widget', props.className );

    return (
        <div className={ widgetClassName }>
            <TableSearchWidget
                className='ui-auth-flow-member-verification-member-search-widget__table-search'
                layoutConfig={ layoutConfig }
                tableResponse={ props.componentData }
                onActionClick={ props.onActionClick }
                requestPayload= { props.requestPayload }
                templateType = { TABLE_TEMPLATE_TYPE.ADVANCED_SEARCH }
                callState={ props.callState }
            />
        </div>
    );
};

// set display name
authFlowMemberVerificationMemberSearchWidgetSuccess.displayName = 'authFlowMemberVerificationMemberSearchWidgetSuccess';

// set default props
authFlowMemberVerificationMemberSearchWidgetSuccess.defaultProps = {};

// prop types
authFlowMemberVerificationMemberSearchWidgetSuccess.propTypes = {};

/*******************************/

// preloader view
export const authFlowMemberVerificationMemberSearchWidgetPreloader = () => {
    return (
        <div className='ui-auth-flow-member-verification-member-search-widget-preloader'>
            <SearchInputPreloader/>
        </div>
    );
};

// set display name
authFlowMemberVerificationMemberSearchWidgetPreloader.displayName = 'authFlowMemberVerificationMemberSearchWidgetPreloader';

// set default props
authFlowMemberVerificationMemberSearchWidgetPreloader.defaultProps = {};

// prop types
authFlowMemberVerificationMemberSearchWidgetPreloader.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { authFlowMemberVerificationMemberSearchWidget as AuthFlowMemberVerificationMemberSearchWidget } from 'ui/views/widgets/authFlowMemberVerificationMemberSearchWidget';
 *
 * // render
 * <AuthFlowMemberVerificationMemberSearchWidget propName='propValue'/>
 */
export const authFlowMemberVerificationMemberSearchWidget = withNetworkState( authFlowMemberVerificationMemberSearchWidgetPreloader, authFlowMemberVerificationMemberSearchWidgetSuccess );
